"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_CONNECTED_STATUS = exports.UPDATE_CATEGORY_FILTER = exports.SET_CATEGORY_SLUG = exports.PRODUCT_TYPES = exports.NUM_DAYS_FROM_ENTRY_THAT_LISTING_IS_CONSIDERED_NEWLY_RELEASED = exports.LISTINGS_SET_SEARCH = exports.LISTINGS_INVALID = exports.LISTINGS_FETCH_FAILED = exports.LISTINGS_FETCHING = exports.LISTINGS_FETCHED = exports.FILTER_BY_CATEGORY = exports.FETCH_CATEGORIES = exports.CATEGORIES_FETCH_FAILED = exports.CATEGORIES_FETCHED = void 0;
exports.applyListingFilters = applyListingFilters;
exports.default = listings;
exports.fetchListings = fetchListings;
exports.fetchListingsIfNeeded = fetchListingsIfNeeded;
exports.filterByField = filterByField;
exports.filterListingsBySearchTerm = filterListingsBySearchTerm;
exports.flattenCategories = flattenCategories;
exports.initialState = void 0;
exports.resetSearchAndFilters = resetSearchAndFilters;
exports.searchListings = searchListings;
exports.setCategorySlug = setCategorySlug;
exports.setInitialFilterValues = setInitialFilterValues;
exports.setMainFilterValues = setMainFilterValues;
exports.setSearch = setSearch;
exports.setShowNewlyReleasedApps = setShowNewlyReleasedApps;
exports.setShowUnlocalizedListings = setShowUnlocalizedListings;
exports.shouldFetchListings = shouldFetchListings;
exports.unionByID = void 0;
exports.updateCategoryFilter = updateCategoryFilter;
exports.updateConnectedStatus = updateConnectedStatus;
var _objectAssign = _interopRequireDefault(require("object-assign"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));
var _utils = require("../utils");
var _constants = require("./constants");
var userProfileActions = _interopRequireWildcard(require("../userProfile/userProfileModule"));
var _helpers = _interopRequireDefault(require("./FilterBar/helpers"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _ = require('lodash');

// Constants
var LISTINGS_INVALID = exports.LISTINGS_INVALID = '@@listings/LISTINGS_INVALID';
var LISTINGS_SET_SEARCH = exports.LISTINGS_SET_SEARCH = '@@listings/LISTINGS_SET_SEARCH';
var LISTINGS_FETCHING = exports.LISTINGS_FETCHING = '@@listings/LISTINGS_FETCHING';
var LISTINGS_FETCHED = exports.LISTINGS_FETCHED = '@@listings/LISTINGS_FETCHED';
var LISTINGS_FETCH_FAILED = exports.LISTINGS_FETCH_FAILED = '@@listings/LISTINGS_FETCH_FAILED';
var UPDATE_CONNECTED_STATUS = exports.UPDATE_CONNECTED_STATUS = '@@listings/UPDATE_CONNECTED_STATUS';
var FETCH_CATEGORIES = exports.FETCH_CATEGORIES = '@@listings/FETCH_CATEGORIES';
var CATEGORIES_FETCHED = exports.CATEGORIES_FETCHED = '@@listings/CATEGORIES_FETCHED';
var CATEGORIES_FETCH_FAILED = exports.CATEGORIES_FETCH_FAILED = '@@listings/CATEGORIES_FETCH_FAILED';
var FLATTEN_CATEGORIES = '@@listings/FLATTEN_CATEGORIES';
var UPDATE_CATEGORY_FILTER = exports.UPDATE_CATEGORY_FILTER = '@@listings/UPDATE_CATEGORY_FILTER';
var SET_CATEGORY_SLUG = exports.SET_CATEGORY_SLUG = '@@listings/SET_CATEGORY_SLUG';
var FILTER_BY_CATEGORY = exports.FILTER_BY_CATEGORY = '@@listings/FILTER_BY_CATEGORY';
var RESET_SEARCH_AND_FILTERING = '@@listings/RESET_SEARCH_AND_FILTERING';
var SEARCH_LISTINGS = '@@listings/SEARCH_LISTINGS';
var TRIGGER_LISTINGS_FILTERING = '@@listings/APPLY_LISTING_FILTERS';
var SET_INITIAL_FILTERS = '@@listings/SET_INITIAL_FILTERS';
var SET_MAIN_FILTER_VALUES = '@@listings/SET_MAIN_FILTER_VALUES';
var SET_SHOW_UNLOCALIZED_LISTINGS = '@@listings/SET_SHOW_UNLOCALIZED_LISTINGS';
var SET_SHOW_NEWLY_RELEASED_APPS = '@@listings/SET_SHOW_NEWLY_RELEASED_APPS';
var NUM_DAYS_FROM_ENTRY_THAT_LISTING_IS_CONSIDERED_NEWLY_RELEASED = exports.NUM_DAYS_FROM_ENTRY_THAT_LISTING_IS_CONSIDERED_NEWLY_RELEASED = 90;
var PRODUCT_TYPES = exports.PRODUCT_TYPES = [{
  id: 'INVSTD'
}, {
  id: 'INVPRO'
}, {
  id: 'TRVSTD'
}, {
  id: 'TRVPRO'
}, {
  id: 'TRQPRO'
}, {
  id: 'TRIPLINK'
}, {
  id: 'EXPSTD'
}, {
  id: 'EXPPRO'
}];
function flattenCategoriesHelper(categories) {
  return categories.flatMap(function (category) {
    return [category].concat(_toConsumableArray(category.subcategories));
  });
}

// Actions
function setMainFilterValues(_ref) {
  var categoryFilter = _ref.categoryFilter,
    countryFilter = _ref.countryFilter,
    productFilter = _ref.productFilter,
    regionFilter = _ref.regionFilter;
  return {
    type: SET_MAIN_FILTER_VALUES,
    categoryFilter: categoryFilter,
    countryFilter: countryFilter,
    productFilter: productFilter,
    regionFilter: regionFilter
  };
}
function setInitialFilterValues(_ref2) {
  var localizedCountries = _ref2.localizedCountries,
    localizedRegions = _ref2.localizedRegions,
    profile = _ref2.profile,
    offeringsEnabled = _ref2.offeringsEnabled,
    country = _ref2.country;
  return {
    type: SET_INITIAL_FILTERS,
    localizedCountries: localizedCountries,
    localizedRegions: localizedRegions,
    profile: profile,
    offeringsEnabled: offeringsEnabled,
    country: country
  };
}
function setShowNewlyReleasedApps(showNewlyReleasedApps) {
  return {
    type: SET_SHOW_NEWLY_RELEASED_APPS,
    value: showNewlyReleasedApps
  };
}
function setShowUnlocalizedListings(showUnlocaliedListings) {
  return {
    type: SET_SHOW_UNLOCALIZED_LISTINGS,
    value: showUnlocaliedListings
  };
}
function setSearch(value) {
  return {
    type: LISTINGS_SET_SEARCH,
    value: value
  };
}
function updateConnectedStatus(listingId, status) {
  return function (dispatch, getState) {
    var _getState$listings = getState().listings,
      list = _getState$listings.list,
      filtered = _getState$listings.filtered;
    var updateList = function updateList(listToUpdate) {
      return listToUpdate.map(function (el) {
        if (el.ID === listingId) {
          return (0, _merge2.default)({}, el, {
            isConnecting: false,
            core: {
              isUserConnected: status
            }
          });
        }
        return el;
      });
    };
    if (list.length > 0 || filtered.length > 0) {
      var newList = updateList(list);
      var newFilteredList = updateList(filtered);
      dispatch({
        type: UPDATE_CONNECTED_STATUS,
        newList: newList,
        newFilteredList: newFilteredList
      });
    }
  };
}
function resetSearchAndFilters() {
  return {
    type: RESET_SEARCH_AND_FILTERING
  };
}

// These countries should filter for American English listings in the public site
var ENGLISH_LISTINGS_COUNTRIES = Object.freeze(['KR', 'HK', 'IN', 'SG']);
function updateCategoryFilter() {
  var selectedCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    type: UPDATE_CATEGORY_FILTER,
    categoryFilter: selectedCategories
  };
}
function fetchListings() {
  return /*#__PURE__*/function () {
    var _asyncFetchListings = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var _getState, _getState$userPrefs$l, lang, _getState$userProfile, _getState$userProfile2, profile, _getState$userProfile3, offeringsEnabled, _getState$listings2, initialSearch, doInitialFiltering, meta, betas, parameters, filterLanguage, endpoint, fetchListingsCall, _fetchListingsCall, listingsResponse, approvedAndVisible, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _fetchListingsCall = function _fetchListingsCall3() {
              _fetchListingsCall = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                var options, response;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      options = {
                        method: 'GET',
                        headers: {}
                      };
                      options.credentials = 'include';
                      _context.n = 1;
                      return (0, _isomorphicFetch.default)(endpoint, options);
                    case 1:
                      response = _context.v;
                      return _context.a(2, response.json());
                  }
                }, _callee);
              }));
              return _fetchListingsCall.apply(this, arguments);
            };
            fetchListingsCall = function _fetchListingsCall2() {
              return _fetchListingsCall.apply(this, arguments);
            };
            _context2.n = 1;
            return dispatch(userProfileActions.fetchUserProfileIfNeeded());
          case 1:
            dispatch({
              type: LISTINGS_FETCHING
            });
            _getState = getState(), _getState$userPrefs$l = _getState.userPrefs.localeData.lang, lang = _getState$userPrefs$l === void 0 ? 'en-us' : _getState$userPrefs$l, _getState$userProfile = _getState.userProfile, _getState$userProfile2 = _getState$userProfile.profile, profile = _getState$userProfile2 === void 0 ? {} : _getState$userProfile2, _getState$userProfile3 = _getState$userProfile.offeringsEnabled, offeringsEnabled = _getState$userProfile3 === void 0 ? [] : _getState$userProfile3, _getState$listings2 = _getState.listings, initialSearch = _getState$listings2.initialSearch, doInitialFiltering = _getState$listings2.doInitialFiltering, meta = _getState.meta, betas = _getState.betas;
            parameters = {};
            filterLanguage = meta.isPublic && ENGLISH_LISTINGS_COUNTRIES.includes(meta.country) ? 'en' : lang;
            parameters.lang = filterLanguage;
            if (!meta.isPublic) {
              parameters.useCountryFilter = 'false';
            }
            parameters.schema = 'AppCenterCompact';
            endpoint = "".concat((0, _utils.getAPIEndpoint)(profile), "/listings").concat((0, _utils.buildQueryString)(parameters));
            _context2.p = 2;
            _context2.n = 3;
            return fetchListingsCall();
          case 3:
            listingsResponse = _context2.v;
            approvedAndVisible = listingsResponse.items.filter(function (item) {
              var isTripLinkOnlyListing = item.core.offerings.length === 1 && item.core.offerings.includes('TRIPLINK');
              // filter out apps without a compatible public site setting
              if ((betas || {})['appmgt-2292']) {
                if (_.isEmpty((item.core || {}).publicSites)) {
                  // okay
                } else {
                  var countryCode = (0, _utils.getCountryCode)(window.location.href);
                  if (!item.core.publicSites.includes(countryCode)) {
                    return false;
                  }
                }
              }

              // If listing is not visible, not approved, we do not show it.
              if (item.core.isVisible && item.core.approvalStatus === 'APPROVED') {
                // If this is not the public site, or the listing is a user listing, we must make sure the
                //  user has this offering enabled.
                if (!meta.isPublic && item.core.clientOptInType === 'USER') {
                  // make sure user has offering enabled
                  if ((0, _intersection2.default)(item.core.offerings, offeringsEnabled).length > 0) {
                    return true;
                  }
                  // If we get all the way here: We are not on public site and the user does not
                  //  have any of the offerings that overlap the offerings of the listing.
                  // In that case, the listings must not be triplink only if we want to show it to the user
                  return !isTripLinkOnlyListing;
                }
                return true;
              }
              return false;
            });
            dispatch({
              type: LISTINGS_FETCHED,
              result: approvedAndVisible
            });
            if (!initialSearch && doInitialFiltering) {
              dispatch(applyListingFilters());
            }
            dispatch(searchListings(initialSearch));
            _context2.n = 5;
            break;
          case 4:
            _context2.p = 4;
            _t = _context2.v;
            dispatch({
              type: LISTINGS_FETCH_FAILED,
              error: _t
            });
          case 5:
            return _context2.a(2);
        }
      }, _callee2, null, [[2, 4]]);
    }));
    function asyncFetchListings(_x, _x2) {
      return _asyncFetchListings.apply(this, arguments);
    }
    return asyncFetchListings;
  }();
}
function setCategorySlug(slug) {
  return {
    type: SET_CATEGORY_SLUG,
    slug: slug
  };
}
function shouldFetchListings(state, isKeywordEntered) {
  var currentListings = state.listings;
  if (currentListings.list === null || currentListings.list.length === 0 || currentListings.listingsReadyState === LISTINGS_FETCH_FAILED || currentListings.listingsReadyState === LISTINGS_INVALID || isKeywordEntered) {
    return true;
  }
  return false;
}
function fetchListingsIfNeeded() {
  return function (dispatch, getState) {
    if (shouldFetchListings(getState(), getState().listings.initialSearch.length > 0)) {
      return dispatch(fetchListings());
    }
  };
}
function searchListings(searchTerm) {
  return {
    data: searchTerm,
    type: SEARCH_LISTINGS
  };
}
function flattenCategories() {
  return {
    type: FLATTEN_CATEGORIES
  };
}
function applyListingFilters() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$doNotModifyUrl = _ref3.doNotModifyUrl,
    doNotModifyUrl = _ref3$doNotModifyUrl === void 0 ? false : _ref3$doNotModifyUrl;
  return {
    type: TRIGGER_LISTINGS_FILTERING,
    doNotModifyUrl: doNotModifyUrl
  };
}

// Reducer

var initialState = exports.initialState = {
  listingsReadyState: LISTINGS_INVALID,
  list: [],
  searchFilteredListings: [],
  lastSearch: '',
  initialSearch: '',
  filtered: [],
  categoryFilter: [],
  categories: [],
  categorySlug: undefined,
  productFilter: [],
  countryFilter: [],
  regionFilter: [],
  doInitialFiltering: false,
  showUnlocalizedListings: false,
  showNewlyReleasedApps: false
};
function filterByField(_ref4, field) {
  var search = _ref4.search,
    list = _ref4.list;
  return list.filter(function (listing) {
    var localized = listing.localized;
    if (!localized || !localized[field]) {
      return false;
    }
    var lowCaseSearch = search.toLowerCase();
    var containsJapanese = lowCaseSearch.match(/[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/);
    var lowCaseSearchRegExp = containsJapanese ? new RegExp(lowCaseSearch, 'gi') : new RegExp("\\b".concat(lowCaseSearch, "\\b"), 'gi');
    if (field === 'keywords') {
      var keywords = localized.keywords;
      if (keywords && keywords.length > 0) {
        return (0, _some2.default)(keywords, function (value) {
          if (lowCaseSearch === '') {
            return false;
          }
          var keywordMatches = value.toLowerCase().match(lowCaseSearchRegExp);
          return keywordMatches && keywordMatches.length > 0;
        });
      }
    }
    var lowCaseField = '';
    if ((0, _isString2.default)(localized[field])) {
      lowCaseField = localized[field].toLowerCase();
    }
    var wordMatches = lowCaseField.match(lowCaseSearchRegExp);
    return wordMatches && wordMatches.length > 0;
  });
}
function filterListings(_ref5) {
  var allListings = _ref5.listings,
    _ref5$categoryFilter = _ref5.categoryFilter,
    categoryFilter = _ref5$categoryFilter === void 0 ? [] : _ref5$categoryFilter,
    _ref5$productFilter = _ref5.productFilter,
    productFilter = _ref5$productFilter === void 0 ? [] : _ref5$productFilter,
    _ref5$countryFilter = _ref5.countryFilter,
    countryFilter = _ref5$countryFilter === void 0 ? [] : _ref5$countryFilter,
    _ref5$regionFilter = _ref5.regionFilter,
    regionFilter = _ref5$regionFilter === void 0 ? [] : _ref5$regionFilter,
    lang = _ref5.lang,
    showNewlyReleasedApps = _ref5.showNewlyReleasedApps;
  var regionFilteredListings = (regionFilter === null || regionFilter === void 0 ? void 0 : regionFilter.length) <= 0 ? allListings : allListings.filter(function (app) {
    return regionFilter.some(function (region) {
      var _app$core$regions$REG;
      return ((_app$core$regions$REG = app.core.regions[_constants.REGION_CODE_TO_LISTING[region.code]]) === null || _app$core$regions$REG === void 0 ? void 0 : _app$core$regions$REG.length) > 0;
    });
  });
  var categoryFilteredListings = categoryFilter.length ? regionFilteredListings.filter(function (listing) {
    return categoryFilter.some(function (category) {
      var _listing$core, _listing$core$categor;
      return (_listing$core = listing.core) === null || _listing$core === void 0 ? void 0 : (_listing$core$categor = _listing$core.categories) === null || _listing$core$categor === void 0 ? void 0 : _listing$core$categor.includes(category.code);
    });
  }) : regionFilteredListings;
  var productFiltered = productFilter.length ? categoryFilteredListings.filter(function (listing) {
    return productFilter.some(function (product) {
      var _listing$core2, _listing$core2$offeri;
      return (_listing$core2 = listing.core) === null || _listing$core2 === void 0 ? void 0 : (_listing$core2$offeri = _listing$core2.offerings) === null || _listing$core2$offeri === void 0 ? void 0 : _listing$core2$offeri.includes(product.id);
    });
  }) : categoryFilteredListings;
  var countryFilteredListings = countryFilter.length <= 0 ? productFiltered : productFiltered.filter(function (listing) {
    return countryFilter.some(function (country) {
      return Object.values(listing.core.regions).some(function (region) {
        return region.includes(country.code);
      });
    });
  });
  var filteredForNewlyReleasedListings = showNewlyReleasedApps ? countryFilteredListings.filter(function (listing) {
    if ((listing.core || {}).dateOfEntryToNewlyReleasedSection) {
      var dayDiff = Date.now() - new Date(listing.core.dateOfEntryToNewlyReleasedSection);
      return Math.ceil(dayDiff / (1000 * 60 * 60 * 24)) <= NUM_DAYS_FROM_ENTRY_THAT_LISTING_IS_CONSIDERED_NEWLY_RELEASED;
    }
    return false;
  }) : countryFilteredListings;
  var fixedLang = lang === 'en' ? 'en-us' : lang;
  return fixedLang ? filteredForNewlyReleasedListings.filter(function (listing) {
    var _listing$localized;
    return (listing === null || listing === void 0 ? void 0 : (_listing$localized = listing.localized) === null || _listing$localized === void 0 ? void 0 : _listing$localized.lang) === fixedLang;
  }) : filteredForNewlyReleasedListings;
}
var unionByID = exports.unionByID = function unionByID(sets) {
  var result = (0, _uniqBy2.default)(sets, 'ID');
  return result;
};
function filterListingsBySearchTerm(listings, term) {
  var params = {
    search: term,
    list: listings
  };
  return unionByID([].concat(_toConsumableArray(filterByField(params, 'title')), _toConsumableArray(filterByField(params, 'publisher')), _toConsumableArray(filterByField(params, 'keywords')), _toConsumableArray(filterByField(params, 'name'))));
}
function readMainFiltersFromQuery(flattenedCategories, localizedCountries, localizedRegions) {
  var _window, _window$location;
  var filters = {};
  if (!((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.href)) {
    return filters;
  }
  var _URL = new URL(window.location.href),
    searchParams = _URL.searchParams,
    pathname = _URL.pathname;

  // For the scenario where 'back' is pressed on browser and we go from
  // /nui/appcenter?category=foo back to /nui/appcenter/category/bar
  if (pathname.includes('/category/')) {
    var splitPath = pathname.split('/');
    var slug = splitPath[splitPath.findIndex(function (subpath) {
      return subpath.toLowerCase() === 'category';
    }) + 1];
    var selectedCategory = flattenedCategories.find(function (category) {
      return category.slug === slug;
    });
    if (selectedCategory) {
      filters.categoryFilter = [selectedCategory];
    }
  }
  var categoryQuery = searchParams.get(_constants.MAIN_FILTER_QUERY_PARAMS.CATEGORY);
  if (categoryQuery) {
    var moreCategories = categoryQuery.split(',').filter(function (query) {
      var _filters$categoryFilt;
      return !((_filters$categoryFilt = filters.categoryFilter) !== null && _filters$categoryFilt !== void 0 && _filters$categoryFilt.length) || filters.categoryFilter[0].slug !== query;
    }).map(function (categorySlug) {
      return flattenedCategories.find(function (category) {
        return category.slug === categorySlug;
      });
    }).filter(function (category) {
      return !!category;
    });
    filters.categoryFilter = [].concat(_toConsumableArray(filters.categoryFilter || []), _toConsumableArray(moreCategories));
  }
  var productQuery = searchParams.get(_constants.MAIN_FILTER_QUERY_PARAMS.PRODUCT);
  if (productQuery) {
    filters.productFilter = productQuery.split(',').map(function (productId) {
      return PRODUCT_TYPES.find(function (product) {
        return product.id === productId;
      });
    }).filter(function (product) {
      return !!product;
    });
  }
  var countryQuery = searchParams.get(_constants.MAIN_FILTER_QUERY_PARAMS.COUNTRY);
  if (countryQuery) {
    filters.countryFilter = countryQuery.split(',').map(function (countryCode) {
      return localizedCountries.find(function (country) {
        return country.code === countryCode;
      });
    }).filter(function (country) {
      return !!country;
    });
  }
  var regionQuery = searchParams.get(_constants.MAIN_FILTER_QUERY_PARAMS.REGION);
  if (regionQuery) {
    filters.regionFilter = regionQuery.split(',').map(function (regionCode) {
      return localizedRegions.find(function (region) {
        return region.code === regionCode;
      });
    }).filter(function (x) {
      return !!x;
    });
  }
  return filters;
}
function readCheckboxFiltersFromQuery() {
  var _window2, _window2$location;
  var filters = {};
  if (!((_window2 = window) !== null && _window2 !== void 0 && (_window2$location = _window2.location) !== null && _window2$location !== void 0 && _window2$location.href)) {
    return filters;
  }
  var _URL2 = new URL(window.location.href),
    searchParams = _URL2.searchParams;
  filters.newlyReleasedAppsQuery = searchParams.get(_constants.CHECKBOX_FILTER_QUERY_PARAMS.NEWLY_RELEASED_APPS);
  return filters;
}
function listings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case LISTINGS_FETCHING:
      return (0, _objectAssign.default)({}, state, {
        listingsReadyState: LISTINGS_FETCHING
      });
    case LISTINGS_SET_SEARCH:
      return (0, _objectAssign.default)({}, state, {
        initialSearch: action.value
      });
    case LISTINGS_FETCH_FAILED:
      return (0, _objectAssign.default)({}, state, {
        listingsReadyState: LISTINGS_FETCH_FAILED,
        error: action.error
      });
    case LISTINGS_FETCHED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          listingsReadyState: LISTINGS_FETCHED,
          list: action.result,
          filtered: action.result
        });
      }
    case UPDATE_CONNECTED_STATUS:
      return (0, _merge2.default)({}, state, {
        list: action.newList,
        filtered: action.newFilteredList
      });
    case FETCH_CATEGORIES:
      return (0, _objectAssign.default)({}, state, {
        categoriesReadyState: FETCH_CATEGORIES
      });
    case CATEGORIES_FETCHED:
      return (0, _objectAssign.default)({}, state, {
        categoriesReadyState: CATEGORIES_FETCHED,
        categories: action.result
      });
    case CATEGORIES_FETCH_FAILED:
      return (0, _objectAssign.default)({}, state, {
        categoriesReadyState: CATEGORIES_FETCH_FAILED,
        error: action.error
      });
    case FLATTEN_CATEGORIES:
      return _objectSpread(_objectSpread({}, state), {}, {
        flattenedCategories: flattenCategoriesHelper(state.categories)
      });
    // for the legacy category filter menu
    case UPDATE_CATEGORY_FILTER:
      {
        var list = state.list;
        var categoryFilter = action.categoryFilter;
        var shouldFilter = categoryFilter.length && categoryFilter[0].slug !== 'all';
        return _objectSpread(_objectSpread({}, state), {}, {
          filtered: shouldFilter ? filterListings({
            listings: list,
            categoryFilter: categoryFilter
          }) : list,
          search: '',
          categoryFilter: categoryFilter
        });
      }
    case TRIGGER_LISTINGS_FILTERING:
      {
        var _list = state.list,
          flattenedCategoriesFromStore = state.flattenedCategories,
          categories = state.categories,
          listingsReadyState = state.listingsReadyState,
          showUnlocalizedListings = state.showUnlocalizedListings,
          showNewlyReleasedApps = state.showNewlyReleasedApps;
        // We can not filter the listings if the listings haven't been fetched yet.
        if (listingsReadyState !== LISTINGS_FETCHED) {
          return _objectSpread(_objectSpread({}, state), {}, {
            // Setting this to true will make this action be dispatched again by the fetch listings action
            // after the listings are fetched
            doInitialFiltering: true
          });
        }
        var flattenedCategories = flattenedCategoriesFromStore || flattenCategoriesHelper(categories);
        var _action$categoryFilte = action.categoryFilter,
          _categoryFilter = _action$categoryFilte === void 0 ? state.categoryFilter : _action$categoryFilte,
          _action$productFilter = action.productFilter,
          productFilter = _action$productFilter === void 0 ? state.productFilter : _action$productFilter,
          _action$countryFilter = action.countryFilter,
          countryFilter = _action$countryFilter === void 0 ? state.countryFilter : _action$countryFilter,
          _action$regionFilter = action.regionFilter,
          regionFilter = _action$regionFilter === void 0 ? state.regionFilter : _action$regionFilter,
          _action$meta = action.meta,
          _action$meta2 = _action$meta === void 0 ? {} : _action$meta,
          _action$meta2$localeD = _action$meta2.localeData,
          _action$meta2$localeD2 = _action$meta2$localeD === void 0 ? {} : _action$meta2$localeD,
          lang = _action$meta2$localeD2.lang;
        if (!action.doNotModifyUrl) {
          window.history.replaceState({}, '', (0, _helpers.default)({
            categoryFilter: _categoryFilter,
            productFilter: productFilter,
            countryFilter: countryFilter,
            regionFilter: regionFilter,
            showNewlyReleasedApps: showNewlyReleasedApps
          }));
        }
        var _shouldFilter = _categoryFilter.length && _categoryFilter[0].slug !== 'all' || productFilter.length || countryFilter.length || regionFilter.length || showNewlyReleasedApps || !showUnlocalizedListings;
        var filterArgs = {
          listings: _list,
          categoryFilter: _categoryFilter,
          productFilter: productFilter,
          countryFilter: countryFilter,
          regionFilter: regionFilter,
          showNewlyReleasedApps: showNewlyReleasedApps
        };
        if (!showUnlocalizedListings) {
          filterArgs.lang = lang;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          filtered: _shouldFilter ? filterListings(filterArgs) : _list,
          search: '',
          categoryFilter: _categoryFilter,
          flattenedCategories: flattenedCategories,
          productFilter: productFilter,
          countryFilter: countryFilter,
          regionFilter: regionFilter
        });
      }
    case SET_INITIAL_FILTERS:
      {
        var _flattenedCategoriesFromStore = state.flattenedCategories,
          _categories = state.categories;
        var localizedCountries = action.localizedCountries,
          localizedRegions = action.localizedRegions,
          profile = action.profile,
          offeringsEnabled = action.offeringsEnabled,
          country = action.country;
        var _flattenedCategories = _flattenedCategoriesFromStore || flattenCategoriesHelper(_categories);
        var mainQueryFilters = readMainFiltersFromQuery(_flattenedCategories, localizedCountries, localizedRegions);
        var checkboxQueryFilters = readCheckboxFiltersFromQuery();

        // If there are filters in the querystring, filter based off the querystring filters
        if (Object.values(mainQueryFilters).some(function (filter) {
          return filter.length > 0;
        }) || Object.values(checkboxQueryFilters).some(function (filter) {
          return filter === 'true';
        })) {
          return _objectSpread(_objectSpread(_objectSpread({}, state), {}, {
            flattenedCategories: _flattenedCategories
          }, mainQueryFilters), {}, {
            showUnlocalizedListings: false,
            showNewlyReleasedApps: checkboxQueryFilters.newlyReleasedAppsQuery === 'true',
            firstListingsPageLoadComplete: true
          });
        }
        // If there is no profile (ie, public site), filter based on the public site country
        if (!profile || !Object.values(profile).length) {
          var matchingCountry = localizedCountries.find(function (localizedCountry) {
            return localizedCountry.code.toLowerCase() === country.toLowerCase();
          });
          // If the public site is US, we want all listings to be shown because we treat the US site as the Global site.
          var _countryFilter = matchingCountry && (country === null || country === void 0 ? void 0 : country.toLowerCase()) !== 'us' ? [matchingCountry] : [];
          return _objectSpread(_objectSpread({}, state), {}, {
            categoryFilter: [],
            productFilter: [],
            regionFilter: [],
            countryFilter: _countryFilter,
            showUnlocalizedListings: false,
            showNewlyReleasedApps: false,
            firstListingsPageLoadComplete: true
          });
        }
        // If we are neither on the public site nor are there filters in the querystring,
        // filter the lisings based on user's profile
        var usersCountryCode = profile.Country && localizedCountries.find(function (localizedCountry) {
          return localizedCountry.code === profile.Country;
        });
        var _countryFilter2 = usersCountryCode ? [usersCountryCode] : [];
        var _productFilter = offeringsEnabled.map(function (offering) {
          return PRODUCT_TYPES.find(function (product) {
            return product.id === offering;
          });
        }).filter(function (x) {
          return x;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          flattenedCategories: _flattenedCategories,
          countryFilter: _countryFilter2,
          productFilter: _productFilter,
          showUnlocalizedListings: false,
          showNewlyReleasedApps: false,
          firstListingsPageLoadComplete: true
        });
      }
    case SET_CATEGORY_SLUG:
      return (0, _objectAssign.default)({}, state, {
        categorySlug: action.slug
      });
    case RESET_SEARCH_AND_FILTERING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          search: ''
        });
      }
    case SEARCH_LISTINGS:
      {
        var data = action.data,
          _action$meta3 = action.meta,
          _action$meta4 = _action$meta3 === void 0 ? {} : _action$meta3,
          _action$meta4$localeD = _action$meta4.localeData,
          _action$meta4$localeD2 = _action$meta4$localeD === void 0 ? {} : _action$meta4$localeD,
          _action$meta4$localeD3 = _action$meta4$localeD2.lang,
          _lang = _action$meta4$localeD3 === void 0 ? 'en-us' : _action$meta4$localeD3;
        var newSearchTerm = (data || '').trim();
        if (!newSearchTerm || state.lastSearch === newSearchTerm || state.listingsReadyState !== LISTINGS_FETCHED) {
          return state;
        }
        // In public site, we only want to show localized listings.
        // In private site, show everything.
        var filterLanguage = _lang === 'en' ? 'en-us' : _lang;
        var listToSearch = (0, _utils.isPublic)(window.location.pathname) ? state.list.filter(function (listing) {
          return listing.localized.lang === filterLanguage;
        }) : state.list;
        return _objectSpread(_objectSpread({}, state), {}, {
          lastSearch: newSearchTerm,
          searchFilteredListings: filterListingsBySearchTerm(listToSearch, newSearchTerm)
        });
      }
    case SET_MAIN_FILTER_VALUES:
      {
        var _action$countryFilter2 = action.countryFilter,
          _countryFilter3 = _action$countryFilter2 === void 0 ? state.countryFilter : _action$countryFilter2,
          _action$categoryFilte2 = action.categoryFilter,
          _categoryFilter2 = _action$categoryFilte2 === void 0 ? state.categoryFilter : _action$categoryFilte2,
          _action$productFilter2 = action.productFilter,
          _productFilter2 = _action$productFilter2 === void 0 ? state.productFilter : _action$productFilter2,
          _action$regionFilter2 = action.regionFilter,
          _regionFilter = _action$regionFilter2 === void 0 ? state.regionFilter : _action$regionFilter2;
        return _objectSpread(_objectSpread({}, state), {}, {
          countryFilter: _countryFilter3,
          categoryFilter: _categoryFilter2,
          productFilter: _productFilter2,
          regionFilter: _regionFilter
        });
      }
    case SET_SHOW_NEWLY_RELEASED_APPS:
      {
        var value = action.value;
        var _showNewlyReleasedApps = state.showNewlyReleasedApps;
        if (value === _showNewlyReleasedApps) {
          return state;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          showNewlyReleasedApps: value
        });
      }
    case SET_SHOW_UNLOCALIZED_LISTINGS:
      {
        var _value = action.value;
        var _showUnlocalizedListings = state.showUnlocalizedListings;
        if (_value === _showUnlocalizedListings) {
          return state;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          showUnlocalizedListings: _value
        });
      }
    default:
      return state;
  }
}